import { useState } from "react";

import { generateInvestingSsoToken } from "../../api";

const BackToUnified = () => {
  const [loading, setLoading] = useState(false);

  const ssoUrlSource = sessionStorage.getItem("ssoUrlSource") || "";

  const handleSubmit = async () => {
    setLoading(true);
    try {
      const response = await generateInvestingSsoToken(true);

      if (response) {
        const baseUrl = response?.data?.data?.redirectUrl;

        const updatedRedirectUrl = `${baseUrl}/sso-login/${response?.data?.data.authCode}`;

        if (updatedRedirectUrl) {
          window.open(updatedRedirectUrl.trim(), "_self");
        }
      }
    } catch (error) {
      console.error("Error in redirect action:", error);
    } finally {
      setLoading(false);
    }
  };
  return (
    ssoUrlSource && (
      <button
        className="fixed left-0 top-[100px] flex items-center bg-[#0770d9] text-white pl-1 pr-2 h-9 rounded-r-lg border-0 cursor-pointer transition-shadow text-sm font-medium"
        onClick={handleSubmit}
        disabled={loading}
      >
        {loading ? (
          <span className="flex items-center justify-center mr-2">
            <svg width="14" height="14" viewBox="0 0 50 50">
              <circle
                cx="25"
                cy="25"
                r="20"
                fill="none"
                stroke="#fff"
                strokeWidth="4"
                strokeDasharray="31.4 31.4"
                strokeLinecap="round"
              >
                <animateTransform
                  attributeName="transform"
                  type="rotate"
                  from="0 25 25"
                  to="360 25 25"
                  dur="0.8s"
                  repeatCount="indefinite"
                />
              </circle>
            </svg>
          </span>
        ) : (
          <span className="flex items-center mr-1">
            <svg
              width="16"
              height="16"
              viewBox="0 0 20 20"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M12 15L7 10L12 5"
                stroke="#fff"
                strokeWidth="1.5"
                strokeLinecap="round"
                strokeLinejoin="round"
              />
            </svg>
          </span>
        )}
        <span className="flex items-center">Borderless Home</span>
      </button>
    )
  );
};

export default BackToUnified;
